"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __exports_1 = require("../../../__exports");
var CheckboxSection_1 = require("../CheckboxSection/CheckboxSection");
/* istanbul ignore next */
var SearchCheckboxSection = function (props) {
    var value = props.value, options = props.options, onCheckboxClick = props.onCheckboxClick, onInputChange = props.onInputChange, searchTextboxLabel = props.searchTextboxLabel;
    return (React.createElement("div", null,
        React.createElement(__exports_1.default.SearchTextbox, { ariaLabel: searchTextboxLabel, tag: "search-textbox", onChange: function (changeValue) { return onInputChange && onInputChange(changeValue); }, value: value, onRightIconClick: function () { return onInputChange && onInputChange(''); } }),
        React.createElement(CheckboxSection_1.default, { options: options, onCheckboxClick: function (val, index, option) {
                return onCheckboxClick && onCheckboxClick(val, index, option);
            } })));
};
exports.default = SearchCheckboxSection;
//# sourceMappingURL=SearchCheckboxSection.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/filter-sections/build/control/components/SearchCheckboxSection/SearchCheckboxSection.js
// module id = 739
// module chunks = 0